// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const FormStatus = {
  "CREATED": "CREATED",
  "SUBMITTED": "SUBMITTED",
  "PENDING": "PENDING",
  "DECLINED": "DECLINED",
  "APPROVED": "APPROVED"
};

const Accuracy = {
  "DEFAULT": "DEFAULT",
  "HIGH": "HIGH"
};

const FinalisationStatus = {
  "DRAFT": "DRAFT",
  "READY": "READY",
  "IN_PROGRESS": "IN_PROGRESS",
  "QUERIED": "QUERIED",
  "FILED": "FILED"
};

const AttachmentType = {
  "PDF": "PDF",
  "IMAGE": "IMAGE",
  "DOCUMENT": "DOCUMENT",
  "VIDEO": "VIDEO",
  "AUDIO": "AUDIO"
};

const EvidenceSourceType = {
  "AUDIO": "AUDIO",
  "IMAGE": "IMAGE",
  "PDF": "PDF",
  "DOCUMENT": "DOCUMENT",
  "API": "API"
};

const EvidenceStatus = {
  "PENDING": "PENDING",
  "PROCESSING": "PROCESSING",
  "READY": "READY",
  "FAILED": "FAILED"
};

const ObservationType = {
  "EWS": "EWS"
};

const ObservationState = {
  "STARTED": "STARTED",
  "IN_PROGRESS": "IN_PROGRESS",
  "COMPLETED": "COMPLETED",
  "CANCELLED": "CANCELLED"
};

const ConsciousnessLevel = {
  "ALERT": "ALERT",
  "VERBAL": "VERBAL",
  "PAIN": "PAIN",
  "UNRESPONSIVE": "UNRESPONSIVE"
};

const Oxygen = {
  "ROOM_AIR": "ROOM_AIR",
  "LPM_1": "LPM_1",
  "LPM_2": "LPM_2",
  "LPM_3": "LPM_3",
  "LPM_4": "LPM_4",
  "LPM_5": "LPM_5",
  "LPM_6": "LPM_6",
  "LPM_7": "LPM_7",
  "LPM_8": "LPM_8",
  "LPM_9": "LPM_9",
  "LPM_10": "LPM_10",
  "LPM_11": "LPM_11",
  "LPM_12": "LPM_12",
  "LPM_13": "LPM_13",
  "LPM_14": "LPM_14",
  "LPM_15": "LPM_15"
};

const SubscriptionType = {
  "EXEMPT": "EXEMPT",
  "FREE": "FREE",
  "PAID_INDIVIDUAL": "PAID_INDIVIDUAL",
  "PAID_ORGANISATION": "PAID_ORGANISATION",
  "SUBSIDISED": "SUBSIDISED"
};

const { AssistantDto, ClientVersionDto, ConsultDto, AudioDto, ConsultDiarizationDto, ConsultEntityDto, ConsultTranscriptionDto, ConsultTemplateDto, ConsultPatientDto, ConsultAdditionalTemplateDto, QuestionnaireDto, QuestionnaireVersionDto, ConsultEvidenceDto, ConsultTemplateVersionDto, ConsultFailureLogDto, FormDto, HandshakeDto, AuditLogDto, ErrorLogDto, EventLogDto, ObservationDto, EwsObservation, SubscriptionDto, SubscriptionDomainDto, SubscriptionAccessCodeDto, TemplateCatalogueDto, TemplateCatalogueVersionDto, TuhiUserDto, ValueSetCacheDto, VendorDto, ProviderDto, ProviderDetailsDto, AccPatientDto, PatientDetailsDto, ContactDto, AddressDto, EmploymentDto, EmployerDto, InjuryDto, DiagnosisDto, WorkCapacityDto, DeclarationDto, StateTimestampDto, ConfirmedPatientDetailDto, AttachmentDto, DiarizationDto, EntityDto, TemplateDto, ContentDto, TemplateDeltaMap, FormSectionDto, FormRowDto, FieldDto, CodingDto, PatientDto, PatientIdentifierDto, PatientNameDto, PatientDateDto, PatientAddressDto, EthnicityDto, BirthplaceDto, CitizenshipDto, OutputSectionDto } = initSchema(schema);

export {
  AssistantDto,
  ClientVersionDto,
  ConsultDto,
  AudioDto,
  ConsultDiarizationDto,
  ConsultEntityDto,
  ConsultTranscriptionDto,
  ConsultTemplateDto,
  ConsultPatientDto,
  ConsultAdditionalTemplateDto,
  QuestionnaireDto,
  QuestionnaireVersionDto,
  ConsultEvidenceDto,
  ConsultTemplateVersionDto,
  ConsultFailureLogDto,
  FormDto,
  HandshakeDto,
  AuditLogDto,
  ErrorLogDto,
  EventLogDto,
  ObservationDto,
  EwsObservation,
  SubscriptionDto,
  SubscriptionDomainDto,
  SubscriptionAccessCodeDto,
  TemplateCatalogueDto,
  TemplateCatalogueVersionDto,
  TuhiUserDto,
  ValueSetCacheDto,
  FormStatus,
  Accuracy,
  FinalisationStatus,
  AttachmentType,
  EvidenceSourceType,
  EvidenceStatus,
  ObservationType,
  ObservationState,
  ConsciousnessLevel,
  Oxygen,
  SubscriptionType,
  VendorDto,
  ProviderDto,
  ProviderDetailsDto,
  AccPatientDto,
  PatientDetailsDto,
  ContactDto,
  AddressDto,
  EmploymentDto,
  EmployerDto,
  InjuryDto,
  DiagnosisDto,
  WorkCapacityDto,
  DeclarationDto,
  StateTimestampDto,
  ConfirmedPatientDetailDto,
  AttachmentDto,
  DiarizationDto,
  EntityDto,
  TemplateDto,
  ContentDto,
  TemplateDeltaMap,
  FormSectionDto,
  FormRowDto,
  FieldDto,
  CodingDto,
  PatientDto,
  PatientIdentifierDto,
  PatientNameDto,
  PatientDateDto,
  PatientAddressDto,
  EthnicityDto,
  BirthplaceDto,
  CitizenshipDto,
  OutputSectionDto
};